module.exports = __webpack_public_path__ + "static/media/ts12cr93.d344bd7d.png";